import { render, staticRenderFns } from "./EditMultiplier.vue?vue&type=template&id=52a71a4c&scoped=true"
import script from "./EditMultiplier.vue?vue&type=script&lang=ts"
export * from "./EditMultiplier.vue?vue&type=script&lang=ts"
import style0 from "./EditMultiplier.vue?vue&type=style&index=0&id=52a71a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a71a4c",
  null
  
)

export default component.exports